import type {ProposedCar} from '../models/api.models';

export function getOrderCarCompany(car: Partial<ProposedCar> | undefined): string {
    if (!car) return '-';
    const carId = String(car.CarId ?? '').trim();
    const identifier = String(car.CarIdentifier ?? '').trim();
    let company = String(car.CompanyName ?? '').trim();
    if (!company && carId && identifier.endsWith(carId) && identifier.length > carId.length) {
        company = identifier.slice(0, -carId.length).replace(/[\s_-]+$/, '');
    }
    const companyIdentifier = String(car.CompanyIdentifier ?? '').trim();
    if (!company && companyIdentifier && !/^\d+$/.test(companyIdentifier)) company = companyIdentifier;
    return company ? company.toUpperCase() : '-';
}

export function formatOrderCar(car: Partial<ProposedCar> | undefined): string {
    if (!car) return '-';
    const company = getOrderCarCompany(car);
    const carId = String(car.CarId ?? '').trim();
    if (company !== '-') return [company, carId].filter(Boolean).join(' ');
    return String(car.CarIdentifier ?? '').trim().toUpperCase() || carId || '-';
}

export function getOrderCarEta(car: ProposedCar | undefined): number | undefined {
    const eta = car?.ProposedService?.CarEta;
    return typeof eta === 'number' && Number.isFinite(eta) && eta >= 0 ? eta : undefined;
}

export function formatOrderCarEta(car: ProposedCar | undefined): string {
    const eta = getOrderCarEta(car);
    return eta === undefined ? '-' : `${eta} min`;
}
